<template>
  <div class="sm-notification-top terms">
    <div class="sm-wrap">
      <div 
        class="sm-notification-top__terms"
        @click="handleClick"
      >
        <include-svg :name="'icon-warning-sys'" />
        <span class="sm-small">Schedule mail pickup times</span>
        <a
          href="#"
          class="sm-notification-top__terms-close"
          @click.stop="$emit('close')"
        >
          <include-svg :name="'icon-action-close'" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'schedule-notification',
  methods: {
    handleClick() {
      this.$router.push('/admin/settings?schedule=1');

      this.$emit('close');
    }
  }
}
</script>